import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { useLanguage } from "../../contexts/LanguageContext";
import { SectionCTA } from "../shared/SectionCTA";

export const FAQSection = () => {
  const { language, translations: t } = useLanguage();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id="faq" className="py-20 md:py-28 bg-[#FAF7F2] scroll-mt-20" data-testid="faq-section" ref={ref}>
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
        >
          <span className="text-[#C4956A] font-semibold mb-2 block">{t.faq.label}</span>
          <h2 className="font-['Heebo'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#2C2C2C] mb-4">
            {t.faq.title}
          </h2>
          <div className="w-20 h-1 bg-[#C4956A] mx-auto" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="space-y-4">
            {t.faq.items.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="bg-white rounded-xl border-0 px-6 overflow-hidden shadow-sm hover:shadow-md transition-shadow"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-right font-['Heebo'] font-bold text-[#2C2C2C] hover:text-[#C4956A] py-5 hover:no-underline">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#2C2C2C]/70 pb-5 leading-relaxed">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>

        <SectionCTA text={t.faq.cta} buttonText={t.faq.ctaButton} />
      </div>
    </section>
  );
};
